import { Checkbox } from '@mui/material';
import { Post } from 'lib/types';
import { POST_CARD_IMG_WIDTH, imagePostUrl } from 'lib/utils/imageUtils';
import { buildPostPath } from 'lib/helpers';
import { NetworkIcon } from 'elements/NetworkIcon';
import { CreditsPreview } from 'components/CreditsPreview';
import { PostMetrics } from 'components/PostMetrics';

interface Props {
  post: Post;
  checked?: boolean;
  onChange?: (checked: boolean) => void;
  className?: string;
}

export const SimpleCard = ({
  post, checked, onChange, className,
}: Props) => {
  const thumbnailUrl = imagePostUrl(
    post.thumbnailUrl, { width: POST_CARD_IMG_WIDTH, isDead: !post.isLive },
  );

  return (
    <div
      className={`border bg-white rounded-xl overflow-hidden ${className}`}
    >
      <div className="flex items-center p-2">
        {onChange
          && (
            <Checkbox
              size="small"
              {...(checked !== undefined && { checked })}
              onChange={(_, c) => onChange(c)}
            />
          )}
        <NetworkIcon network={post.network} />
        <div className="font-bold overflow-hidden">
          @
          {post.account}
        </div>
      </div>
      <div className="w-full max-h-36 overflow-hidden">
        <img src={thumbnailUrl} alt={post.caption} className="w-full" />
      </div>
      <PostMetrics post={post} decimals={0} size="small" />
      <CreditsPreview postId={post.id} credits={post.credits} path={buildPostPath(post)} />
    </div>
  );
};
